var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F9FFF9",
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2267 15.1791C11.5056 14.3896 11.9582 13.6472 12.5956 13.0135C14.859 10.7501 18.5275 10.7501 20.7909 13.0135L21.4102 13.6363H19.5886C18.9476 13.6363 18.4297 14.1542 18.4297 14.7952C18.4297 15.4362 18.9476 15.9541 19.5886 15.9541H24.2204C24.8614 15.9541 25.3793 15.4362 25.3793 14.7952V10.1598C25.3793 9.51877 24.8614 9.00091 24.2204 9.00091C23.5794 9.00091 23.0616 9.51877 23.0616 10.1598V12.0139L22.4278 11.3766C19.2591 8.20781 14.1239 8.20781 10.9551 11.3766C10.0715 12.2602 9.43409 13.2996 9.04297 14.4113C8.82931 15.0161 9.148 15.6752 9.74916 15.8889C10.3503 16.1026 11.013 15.7839 11.2267 15.1827V15.1791ZM8.83293 18.3189C8.65186 18.3732 8.47803 18.471 8.33679 18.6158C8.19194 18.7607 8.09416 18.9345 8.04346 19.1228C8.03259 19.1663 8.02173 19.2134 8.01449 19.2604C8.00362 19.322 8 19.3836 8 19.4451V24.0661C8 24.7071 8.51787 25.225 9.15886 25.225C9.79986 25.225 10.3177 24.7071 10.3177 24.0661V22.2155L10.9551 22.8493C14.1239 26.0144 19.2591 26.0144 22.4242 22.8493C23.3078 21.9657 23.9488 20.9263 24.3399 19.8181C24.5536 19.2134 24.2349 18.5543 23.6338 18.3406C23.0326 18.1269 22.3699 18.4456 22.1562 19.0468C21.8774 19.8363 21.4247 20.5787 20.7873 21.2124C18.5239 23.4758 14.8554 23.4758 12.592 21.2124L12.5884 21.2088L11.9691 20.5895H13.7943C14.4353 20.5895 14.9532 20.0716 14.9532 19.4307C14.9532 18.7897 14.4353 18.2718 13.7943 18.2718H9.17335C9.1154 18.2718 9.05746 18.2754 8.99952 18.2827C8.94157 18.2899 8.88725 18.3008 8.83293 18.3189Z",
    fill: "#7ABB5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.33c44bd965f1e4679b75d96fd322eb55.svg";
export { ForwardRef as ReactComponent };